import React, { ReactNode, useContext, useEffect, useState } from 'react';

import HVACSpacesContext from '@totem/components/portfolio/buildings/hvac/HVACSpacesContext';
import { HVACSpace } from '@totem/components/portfolio/buildings/hvac/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  programId?: string;
  children?: ReactNode;
};

const HVACSpacesContainer = ({ buildingId, programId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<HVACSpace[]>([]);
  const [refresh, setRefresh] = useState<boolean>(true);

  useEffect(() => {
    setRefresh(true);
  }, [buildingId, programId]);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    const params = new URLSearchParams();
    if (programId) {
      params.set('programId', programId);
    }

    const query = params.toString() ? `?${params.toString()}` : '';

    fetch(`${BUILDINGS_ENDPOINT}/${buildingId}/optimize/hvac-spaces${query}`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: HVACSpace[]) => {
        setData(Array.isArray(result) ? result : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, buildingId, programId, getApiToken]);

  return (
    <HVACSpacesContext.Provider
      value={{
        loading,
        data,
        buildingId,
        requestRefresh: () => setRefresh(true),
      }}
    >
      {children}
    </HVACSpacesContext.Provider>
  );
};

export default HVACSpacesContainer;
